'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

// Product Item
(0, _jquery2.default)(document).on('click', '.js-product-item-swatch', function (e) {
	e.preventDefault();
	var $this = (0, _jquery2.default)(this);
	var $productItem = $this.parents('.js-product-item');
	var variantId = $this.data('swatch-vid');
	var $variantImage = $productItem.find('[data-image-variant=' + variantId + ']');
	var variantImageData = $variantImage.data('bg-src');
	var $variantPrice = $productItem.find('[data-vid-price=' + variantId + ']');
	var $variantColor = $productItem.find('[data-vid-color=' + variantId + ']');
	var $listBadges = $productItem.find('.js-list-badges');
	var $itemStock = $productItem.find('.js-item-stock');
	var currentStockQuantity = $variantPrice.data('stock-inventory');
	var currentColorURL = $this.data('swatch-link');

	if ($listBadges.length > 0) {
		$itemStock.remove();

		var inventoryStockHtml = '<li class="js-item-stock"><small>Only ' + currentStockQuantity + ' left</small></li>';

		currentStockQuantity < 4 ? $listBadges.append(inventoryStockHtml) : '';
	}

	$variantImage.css({
		'background-image': 'url(' + variantImageData + ')'
	}).addClass('current-image-variant').siblings().removeClass('current-image-variant').parents('a').attr('href', currentColorURL);

	$variantColor.addClass('current-color-name').siblings().removeClass('current-color-name').parents('a').attr('href', currentColorURL);

	$variantPrice.addClass('current-price-variant').siblings().removeClass('current-price-variant');

	$this.parent().addClass('current-swatch-variant').siblings().removeClass('current-swatch-variant');

	$productItem.removeClass('product-item--sold-out');
});